export { LoyaltyPointsMessage } from './LoyaltyPointsMessage'
